import PropTypes from "prop-types";

// Layouts
import DoubleInput from "@/Layouts/components/InputComponents/DoubleInput";

// MUI
import { Stack } from "@mui/material";

export default function MatrixColumn(props) {
	const {
		index = 0,
		item = null,
		backendProductsCount = 0,
		errors = [],
		fromDisabled = false,
		toDisabled = false,
		readOnly = false,
		onActionUpdate = () => {},
	} = props;

	return (
		<Stack>
			<DoubleInput
				firstInput={{
					readOnly,
					data: [
						{
							type: "Unit",
							min: 0,
							max: backendProductsCount,
							decimalsEditable: true,
							decimals: 2,
							dashed: fromDisabled,
						},
					],
					value: item?.from?.value || 0,
					defaultType: item?.from?.input || "Unit",
					disabled: true,
					error: Boolean(errors?.[index]?.from),
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "from", value);
					},
				}}
				secondInput={{
					readOnly,
					data: [
						{
							type: "Unit",
							min: 0,
							max: backendProductsCount,
							decimalsEditable: true,
							decimals: 2,
							dashed: toDisabled,
						},
					],
					value: item?.to?.value || 0,
					defaultType: item?.to?.input || "Unit",
					disabled: toDisabled,
					error: Boolean(errors?.[index]?.to),
					sx: { width: "40px" },
					onActionUpdate: (value) => {
						onActionUpdate?.(0, index, "column", "to", value);
					},
				}}
			/>
		</Stack>
	);
}
MatrixColumn.propTypes = {
	index: PropTypes.number,
	item: PropTypes.shape({
		from: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
		to: PropTypes.shape({
			input: PropTypes.string,
			value: PropTypes.number,
		}),
		commissions: PropTypes.array,
	}),
	backendProductsCount: PropTypes.number,
	errors: PropTypes.array,
	fromDisabled: PropTypes.bool,
	toDisabled: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};
